import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { Toast, ListView, Picker, List, SearchBar } from 'antd-mobile';
import Http from '../../config/axiosUtils';
import Empty from '../../components/common/Empty';

import '../../assets/scss/Custom/customList.scss';

class CustomList extends Component {
  constructor() {
    super();
    const dataSource = new ListView.DataSource({
      rowHasChanged: (row1, row2) => row1 !== row2,
    });
    this.state = {
      dataSource: dataSource, //列表初始化
      isLoading: true, //是否加载中
      initData: [], //总数据
      postData: {
        pageNumber: 1, //当前页数
        pageSize: 9, //每页个数
        mobileLastNum: '',
      },
      totalPage: 0, //总页数
      preArray: [],
      dateList: [], //日期列表
      typeList: [], //类型列表
      nodeDate: '', //当前日期
      nodeCode: '', //当前类型
      emptyData: false,
      isHasData: false,
      firstDate: '', //第一页的第一条数据
    }
  }

  //触底加载
  onEndReached = () => {
    if (!this.state.isLoading) {
      return;
    }
    const postData = this.state.postData;
    postData.pageNumber++;
    this.setState({
      isLoading: true,
      postData: postData,
    });
    setTimeout(() => {
      this.fetchData()
    }, 600);
  }

  //初始化
  componentDidMount() {
    this.fetchDate();
    this.fetchType();
    this.fetchData();
  }

  fetchData = async () => {
    const path = '/spread/web/customer/list';
    const res = await Http.post(path, this.state.postData);
    if (res.code === 0) {
      if (!res.data.content.length) {
        this.setState({
          emptyData: true,
          initData: []
        });
        return;
      }
      const list = res.data.content;
      const result = [];
      let n = 0;
      let next;
      const pre = list[this.state.postData.pageSize - 1] && list[this.state.postData.pageSize - 1].nodeDate;
      if (pre) {
        this.state.preArray.push(pre);
      }
      if (this.state.postData.pageNumber === 1) {
        this.setState({
          firstDate: list[0].nodeDate
        })
      }
      if (this.state.postData.pageNumber > 1) {
        next = list[0] && list[0].nodeDate;
        if (this.state.preArray[this.state.postData.pageNumber - 2] === next) {
          list[0].isFirst = true;
        }
        if (this.state.preArray[this.state.postData.pageNumber - 1] === next && this.state.postData.nodeDate) {
          list[0].isFirst = true;
        }
      }
      for (let i = 0; i < list.length; i++) {
        if ((list[i] && list[i].nodeDate) !== (list[i + 1] && list[i + 1].nodeDate)) {
          result.push(list.slice(n, i + 1));
          n = i + 1;
        }
      }
      this.state.initData = this.state.initData.concat([result]);
      this.setState({
        initData: this.state.initData,
        dataSource: this.state.dataSource.cloneWithRows(this.state.initData),
        isLoading: true,
        postData: this.state.postData,
        preArray: this.state.preArray,
        emptyData: false,
      });
      if (this.state.postData.pageNumber === res.data.totalPages || res.data.totalPages === 0) {
        this.setState({
          isLoading: false
        });
      }
    } else {
      Toast.fail(res.msg, 2);
    }
  }

  //日期
  fetchDate = async () => {
    const path = '/spread/web/customer/nodeDateList';
    const res = await Http.get(path);
    if (res.code === 0) {
      const newArr = res.data.map(a => {
        let arr = [];
        arr.push({label: a, value: a});
        return arr[0];
      });
      newArr.unshift({label: '全部', value: ''});
      this.setState({
        dateList: newArr,
      });
    } else {
      Toast.fail(res.msg, 2);
    }
  }

  //类型
  fetchType = async () => {
    const path = '/spread/web/customer/nodeList';
    const res = await Http.get(path);
    if (res.code === 0) {
      const newArr = res.data.map(a => {
        let arr = [];
        arr.push({label: a.value, value: a.code});
        return arr[0];
      });
      newArr.unshift({label: '全部', value: ''});
      this.setState({
        typeList: newArr,
      });
    } else {
      Toast.fail(res.msg, 2);
    }
  }

  //选择日期
  onChangeDate = (val) => {
    const postData = this.state.postData;
    postData.pageNumber = 1;
    postData.nodeDate = val[0];
    postData.mobileLastNum = '';
    this.setState({
      initData: [],
      postData: postData,
      isHasData: true,
      nodeDate: val,
      firstDate: val[0] ? val : this.state.dateList[1]?.value
    }, () => {
      this.fetchData();
    })
  }

  //类型筛选
  onChangeType = (type) => {
    console.log(type);
    console.log(this.state.typeList);
    console.log(this.state.nodeCode);
    const postData = this.state.postData;
    postData.pageNumber = 1;
    postData.nodeCode = type[0];
    postData.mobileLastNum = '';
    this.setState({
      initData: [],
      postData: postData,
      isHasData: true,
      nodeCode: type
    }, () => {
      this.fetchData();
    })
  }
  // 电话号码筛选
  onMobileChange = (number) => {
    const postData = this.state.postData;
    postData.pageNumber = 1;
    postData.mobileLastNum = number;
    this.setState({
      initData: [],
      postData: postData,
      isHasData: true,
    }, () => {
      this.fetchData();
    })
  }
  handleMobileInput = (number) => {
    console.log('number', number);
    if(/^[0-9]*$/.test(number)){
      const postData = this.state.postData;
      postData.mobileLastNum = number;
      this.setState({
        postData: postData,
      });
    }
  }

  handleCancelClick = () => {
    const postData = this.state.postData;
    postData.pageNumber = 1;
    postData.mobileLastNum = '';
    this.setState({
      initData: [],
      postData: postData,
      isHasData: true,
    }, () => {
      this.fetchData();
    })
  }

  //邀请客户
  btnClickFunc = () => {
    this.props.history.push('/inviteHome/custom');
  }

  render () {
    const row = (rowData, sectionID, rowID) => {
      return (
        <div className='custom-list'>
          <ul className='list'>
            {
              rowData.map((item, index) => {
                return (
                  <div key={index}>
                    <div className='list-wrap'>
                    {(this.state.postData.pageNumber === 1 || !item[0].isFirst) &&
                      <div className='list-date'>
                        <div>
                          {item[0].nodeDate} <i className='iconfont icon-arrrow'></i>
                          <div className='common-pick list-date-pick'>
                            <Picker
                              data={this.state.dateList}
                              value={this.state.nodeDate}
                              cols={1}
                              onChange={this.onChangeDate}
                            >
                              <List.Item arrow="horizontal"></List.Item>
                            </Picker>
                          </div>
                        </div>
                        {item[0].nodeDate === this.state.firstDate && <div>
                          {this.state.typeList?.find((item)=>item.value === this.state.postData.nodeCode && item.value !== "")?.label || "节点类型"} <i className='iconfont icon-arrrow'></i>
                          <div className='common-pick list-type-pick'>
                            <Picker
                              data={this.state.typeList}
                              value={this.state.nodeCode}
                              cols={1}
                              onChange={this.onChangeType}
                            >
                              <List.Item arrow="horizontal"></List.Item>
                            </Picker>
                          </div>
                        </div>}
                        { item[0].nodeDate === this.state.firstDate && <SearchBar style={{ width: '170px', padding: '0px', backgroundColor: '#f5f5f5' }} onCancel={this.handleCancelClick} value={this.state.postData.mobileLastNum}	onChange={(event)=>{this.handleMobileInput(event)}}  onSubmit={(event)=>{this.onMobileChange(event)}} placeholder="手机号后四位" maxLength={4} /> }               
                      </div>}
                    </div>
                    <ul>
                      {
                        item.map((item1, index1) => {
                          return (
                            <Link to={`/customDetail/${item1.id}`} key={index1}>
                              <li>
                                <div className='list-left'>
                                  <div>{item1.name || '未实名'}{item1.customerType === 1 && <span>失活客户</span>}</div>
                                  <div className='left-bottom'>{item1.mobile}</div>
                                </div>
                                <div className='list-right'>
                                  <div className='list-right-data'>
                                    <div>{item1.nodeName}</div>
                                    <div className='left-bottom'>{item1.nodeUpdateTime}</div>
                                  </div>
                                  <i className='iconfont icon-arrrow'></i>
                                </div>
                              </li>
                            </Link>
                          )
                        })
                      }
                    </ul>
                  </div>
                )
              })
            }
          </ul>
        </div>
      );
    };

    return (
      <div>
        <Helmet><title>客户列表</title></Helmet>
        {
          this.state.emptyData ? <div>{this.state.isHasData && <div className='list-date'>
            <div>
              {this.state.firstDate} <i className='iconfont icon-arrrow'></i>
              <div className='common-pick list-date-pick'>
                <Picker
                  data={this.state.dateList}
                  value={this.state.nodeDate}
                  cols={1}
                  onChange={this.onChangeDate}
                >
                  <List.Item arrow="horizontal"></List.Item>
                </Picker>
              </div>
            </div>
            <div>
            {this.state.typeList?.find((item)=>item.value === this.state.postData.nodeCode && item.value !== "")?.label || "节点类型"} <i className='iconfont icon-arrrow'></i>
              <div className='common-pick list-type-pick'>
                <Picker
                  data={this.state.typeList}
                  value={this.state.nodeCode}
                  cols={1}
                  onChange={this.onChangeType}
                >
                  <List.Item arrow="horizontal"></List.Item>
                </Picker>
              </div>
            </div>
            <SearchBar  style={{ padding: '0px',  width: '170px', backgroundColor: '#f5f5f5' }} onCancel={this.handleCancelClick} value={this.state.postData.mobileLastNum}	onChange={(event)=>{this.handleMobileInput(event)}}  onSubmit={(event)=>{this.onMobileChange(event)}} placeholder="手机号后四位" maxLength={4} />         
        </div>}
        <div style={{paddingTop: '0.5rem'}}>{this.state.isHasData ? <Empty tip='暂无数据...' /> : <Empty tip='您还没有客户，快去邀请吧' btnTitle='邀请客户' btnClickFunc={this.btnClickFunc} />}</div></div> : <ListView
          ref={el => this.lv = el}
          dataSource={this.state.dataSource}
          renderFooter={() =>
            (<div style={{ textAlign: 'center', marginTop: '0.1rem' }}>
              {this.state.isLoading ? '加载中...' : '已加载全部~'}
            </div>)}
          renderRow={row}
          style={{height: '13.34rem', overflow: 'auto'}}
          onEndReached={this.onEndReached}
          onEndReachedThreshold={10}
        />
        }
      </div>
    )
  }
}

export default CustomList;
